"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatFileSize = void 0;
var millify_1 = __importDefault(require("millify"));
var formatFileSize = function (size, space) {
  if (space === void 0) {
    space = true;
  }
  return (0, millify_1.default)(size || 0, {
    units: ['B', 'KB', 'MB', 'GB'],
    space: space
  });
};
exports.formatFileSize = formatFileSize;